import React from 'react';
import Text from '../../Text';
import { isString } from '../../utils/StringUtils';
import { MARKETING_LAYOUT_DESCRIPTION } from '../dataHooks';
import { classes } from '../MarketingLayout.st.css.js';
import PropTypes from 'prop-types';
const Description = ({ children, size }) => (React.createElement("div", { className: classes.description }, isString(children) ? (React.createElement(Text, { dataHook: MARKETING_LAYOUT_DESCRIPTION, size: size, secondary: true }, children)) : (React.createElement("div", { "data-hook": MARKETING_LAYOUT_DESCRIPTION }, children))));
Description.propTypes = {
    children: PropTypes.node,
    size: PropTypes.string,
};
export default Description;
//# sourceMappingURL=Description.js.map